"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetSectionGutter = exports.sectionGutter = exports.boundarySectionGutter = void 0;
var helpers_1 = require("../../helpers");
exports.boundarySectionGutter = (0, helpers_1.responsive)({
    xs: 5,
    md: 6,
    xxl: 7,
});
exports.sectionGutter = (0, helpers_1.responsive)({
    xs: 4,
    sm: "48px",
    md: 5,
    xxl: 6,
});
exports.resetSectionGutter = (0, helpers_1.responsive)({
    xs: 0,
    sm: 0,
    md: 0,
    xxl: 0,
});
